import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';

import authReducer from '~/thunks/auth/authSlice';
import masterReducer from '~/thunks/master/masterSlice';
import jobReducer from '~/thunks/job/jobSlice';
import timeClockReducer from '~/thunks/time-clocks/timeClocksSlice';
import tagReducer from '~/thunks/tag/tagSlice';
import accountReducer from '~/thunks/account/accountSlice';
import scheduleReducer from '~/thunks/schedule/scheduleSlice';
import franchiseReducer from '~/thunks/franchise/franchiseSlice';
import userManagementReducer from '~/thunks/userManagement/userManagementSlice';
import crmReducer from '~/thunks/crm/crmSlice';
import jobDetailsReducer from '~/thunks/job-details/jobDetailsSlice';
import estimateSettingReducer from '~/thunks/estimate-setting/estimateSettingSlice';
import smsReducer from '~/thunks/sms/smsSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  master: masterReducer,
  job: jobReducer,
  jobDetails: jobDetailsReducer,
  timeClocks: timeClockReducer,
  tag: tagReducer,
  account: accountReducer,
  schedule: scheduleReducer,
  franchise: franchiseReducer,
  userManagement: userManagementReducer,
  crm: crmReducer,
  estimateSetting: estimateSettingReducer,
  sms: smsReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
